module.exports = __webpack_public_path__ + "static/media/more.11d7b2bb.svg";